import { useContext, useState } from 'react'

import Cookie from 'js-cookie'
import { func } from 'prop-types'
import { useHistory } from 'react-router-dom'

import LoginForm from '../../../Components/anonymous/LoginForm'
import AnonymousFormWrapper from '../../../Components/shared/AnonymousFormWrapper'
import { request } from '../../../utils'
import { Routes } from '../../../routes'
import { HttpMethods } from '../../../utils/apiHelper'
import NonProdEnvironmentBanner from '../../../Components/shared/NonProdEnvironmentBanner'
import { RequestPortalContext } from '../../../Providers/RequestPortalProvider'
import { Cookies } from '../../../utils/Cookie'

const LoginView = props => {
  const { studentEmail } = useContext(RequestPortalContext)

  const [loginPending, setLoginPending] = useState(false)
  const history = useHistory()

  const login = async ({ username, password, remember }) => {
    setLoginPending(true)

    const body = {
      username: username.trim(),
      password
    }

    try {
      const response = await request('/auth', HttpMethods.POST, body)
      const { token } = response

      if (typeof token === 'undefined') {
        setLoginPending(false)
        return
      }

      if (remember) {
        Cookie.set(Cookies.TOKEN, JSON.stringify(token), { expires: 7 })
      } else {
        Cookie.remove(Cookies.TOKEN)
      }

      props.onGetUserContextAndData(token).then(() => {
        if (typeof props.onAfterLogin === 'function') {
          props.onAfterLogin()
        }
      })
      setLoginPending(false)
    } catch (err) {
      Cookie.remove(Cookies.TOKEN)
      console.warn(`Error logging in: ${err.message}`)
    }
  }

  return (
    <AnonymousFormWrapper
      topBanner={<NonProdEnvironmentBanner />}
    >
      <LoginForm
        loginPending={loginPending}
        prefilledEmail={studentEmail}
        onLogin={login}
        onPasswordResetClick={() => {
          history.push(Routes.PASSWORD_RESET_REQUEST)
        }}
      />
    </AnonymousFormWrapper>
  )
}

LoginView.propTypes = {
  onGetUserContextAndData: func.isRequired
}

export default LoginView
